import { Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { ReactNode } from 'react'

interface Props {
  title: ReactNode
  caption: string
  maxWidth?: string
}

export const TitleWithCaptionCell = observer(({ title, caption, maxWidth }: Props) => {
  return (
    <Stack sx={{ maxWidth }}>
      <Typography
        variant='subtitle2'
        sx={{ maxWidth, textOverflow: 'ellipsis', overflow: 'hidden' }}
        title={typeof title === 'string' ? title : undefined}
      >
        {title}
      </Typography>
      <Typography
        variant='caption'
        color='secondary'
        sx={{ maxWidth, textOverflow: 'ellipsis', overflow: 'hidden' }}
        title={caption}
      >
        {caption}
      </Typography>
    </Stack>
  )
})
